import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import * as yup from 'yup';

import Form from '@components/form/form';
import FormButton from '@components/form/form-button';
import FormTextField from '@components/form/form-text-field';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 24px;
`;

const LoginFormArea = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 30px;
  width: 50vw;
  padding: 36px;
  @media only screen and (max-width: 992px) {
    width: 80vw;
    padding: 24px;
  }
`;

const FormHeader = styled.h1`
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 768px) {
    font-size: 24px;
    margin-top: 0;
  }
`;

const FormHeaderDesc = styled.h6`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 48px;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
    margin: 12px 0;
  }
`;

export interface LoginFormValues {
  username: string;
  password: string;
}

interface LoginFeatureProps {
  onSubmit: (values: LoginFormValues) => Promise<void>;
  isPending?: boolean;
  defaultValues?: LoginFormValues;
}

const emptyValues: LoginFormValues = { username: '', password: '' };

function LoginForm({
  onSubmit,
  isPending,
  defaultValues = emptyValues
}: LoginFeatureProps) {
  const intl = useIntl();
  const schema = yup.object({
    username: yup
      .string()
      .required(intl.formatMessage({ id: 'USERNAME_ERROR' })),
    password: yup
      .string()
      .required(intl.formatMessage({ id: 'PASSWORD_ERROR' }))
  });

  return (
    <Container>
      <LoginFormArea>
        <Form schema={schema} defaultValues={defaultValues} onSubmit={onSubmit}>
          <FormHeader>{intl.formatMessage({ id: 'LOGIN_HEADER' })}</FormHeader>
          <FormHeaderDesc>
            {intl.formatMessage({ id: 'LOGIN_HEADER_DESC' })}
          </FormHeaderDesc>
          <FormTextField
            name="username"
            label={intl.formatMessage({ id: 'USERNAME' })}
            type="text"
            autoComplete="off"
          />
          <FormTextField
            name="password"
            label={intl.formatMessage({ id: 'PASSWORD' })}
            type="password"
            style={{ marginTop: 30 }}
            autoComplete="new-password"
          />
          <FormButton
            type="primary"
            htmlType="submit"
            fullWidth
            withRightArrow
            loading={isPending}
            style={{ marginTop: 30 }}
          >
            {intl.formatMessage({ id: 'LOGIN_BUTTON_TITLE' })}
          </FormButton>
        </Form>
      </LoginFormArea>
    </Container>
  );
}

export default LoginForm;
